import { h, Component, createRef } from 'preact'
import cn from 'classnames'
import s from './Input.css'

export interface iInputProps {
  type?: 'text' | 'password'
  value: string | number
  onInput?: (e: Event) => void
  onKeyUp?: (e: Event) => void
  className?: string
  label?: string
  invalid?: boolean
  placeholder?: string
  name?: string
  autoComplete?: 'off' | 'on'
  autoFocus?: boolean
}

export class Input extends Component<iInputProps> {
  static defaultProps = {
    type: 'text'
  }

  ref = createRef<HTMLInputElement>()

  componentDidMount (): void {
    const { current: input } = this.ref
    const { autoFocus } = this.props

    if (input && autoFocus) {
      input.focus()
    }
  }

  render () {
    const {
      className,
      label,
      invalid,
      ...restProps
    } = this.props

    return (
      <label className={cn(s.Input, className)}>
        <input
          className={cn(s.Input__field, {
            [s.Input__field_notEmpty]: restProps.value,
            [s.Input__field_invalid]: invalid,
          })}
          autoComplete="off"
          aria-invalid={invalid}
          {...restProps}
          ref={this.ref}
        />
        {label && (
          <span className={cn(s.Input__label)}>
            {label}
          </span>
        )}
        <span className={s.Input__border}/>
      </label>
    )
  }
}
